<template>
  <!-- <h2>{{ t('account.api_keys_section') }}</h2> -->
  <div class="info-card">
    <button
      @click="showApiKeyModal = true"
      class="api-key-form-button"
    >
      {{ t('account.createNewApiKey') }}
    </button>
    <ApiKeyModal
      v-if="showApiKeyModal"
      :show="showApiKeyModal"
      @close="handleApiKeyModalClose"
      @created="handleApiKeyCreated"
    />
    
    
    <div v-if="apiKeys && apiKeys.length">
      <table class="api-keys-table">
        <thead>
          <tr>
            <th>{{ t('account.apiKeys.name') }}</th>
            <th>{{ t('account.apiKeys.keyId') }}</th>
            <th>{{ t('account.apiKeys.status') }}</th>
            <th>{{ t('account.apiKeys.lastUsed') }}</th>
            <th>{{ t('account.apiKeys.created') }}</th>
            <th>{{ t('account.apiKeys.expires') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="key in apiKeys"
            :key="key.id"
            :class="'api-key-status-' + key.status.toLowerCase()"
          >
            <td class="api-key-label">
              {{ key.name || key.key_id }}
            </td>
            <td class="api-key-id">
              {{ key.key_id }}...
            </td>
            <td class="api-key-status">
              {{ key.status }}
            </td>
            <td class="api-key-last-used">
              {{ key.last_used_date ? new Date(key.last_used_date).toLocaleString() : t('account.apiKeys.neverUsed') }}
            </td>
            <td class="api-key-created">
              {{ new Date(key.creation_date).toLocaleString() }}
            </td>
            <td class="api-key-expiration">
              {{ new Date(key.expiration_date).toLocaleString() }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      <p>{{ t('account.apiKeys.noKeys') }}</p>
    </div>
    <br>
    <div>
      {{ t('account.apiKeys.advancedControls') }} <a
        href="#"
        @click.prevent="gotoPortalAccount"
      >{{ t('account.apiKeys.advancedControlsLink') }}</a>.
    </div>
  </div>
</template>
  
  <script setup>
  import { ref, onMounted } from 'vue';
  import { r7eBaseApp } from '../services/index.js';
  import { defineAsyncComponent } from 'vue';
  import { useI18n } from 'vue-i18n';
  const { t } = useI18n();
  const apiKeys = ref([]);
  const showApiKeyModal = ref(false);
  
  const fetchApiKeys = async () => {
    try {
      apiKeys.value = await r7eBaseApp.getAccountApiKeys();
    } catch (e) {
      apiKeys.value = [];
    }
  };
  
  const handleApiKeyModalClose = async () => {
    showApiKeyModal.value = false;
    await fetchApiKeys();
  };
  
  const handleApiKeyCreated = async () => {
    await fetchApiKeys();
  };
  
  // const gotoPortalAccount = () => {
  //   window.location.href = r7eBaseApp.getCMSUrl('/account/');
  // };

  const gotoPortalAccount = async () => {
    try {
      const response = await r7eBaseApp.requestSignMagicLink({ location: "/account" });
      // console.log('Sign magic link response:', response);
      if (response.status === "success") {
        // console.log('Redirecting to:', response['magic-link']);
        window.location.href = response['magic-link'];
      } else {
        console.error('Sign magic link error:', response.error);
      }
    } catch (error) {
      console.error('Sign magic link error:', error);
    }
  };  
  
  onMounted(async () => {
    await fetchApiKeys();
  });
  
  const ApiKeyModal = defineAsyncComponent(() => import('../components/ApiKeyModal.vue'));
  </script>
  
  <style scoped>
  .info-card {
    background-color: var(--color-frame-bg);
    border: 1px solid var(--color-border);
    padding: 20px;
    border-radius: 5px;
  }
  .info-card p {
    margin: 10px 0;
    font-size: 1.1em;
  }
  .info-card strong {
    color: var(--color-safe);
  }
  .api-key-form-button {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 10px 16px;
    background: var(--color-safe);
    color: var(--color-text-light);
    border: none;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: transform 120ms ease, box-shadow 160ms ease, filter 160ms ease;
    box-shadow: 0 2px 8px rgba(0,0,0,0.10);
    margin-bottom: 16px;
  }
  .api-key-form-button:hover {
    filter: brightness(0.96);
    box-shadow: 0 4px 12px rgba(0,0,0,0.12);
  }
  .api-key-form-button:active {
    transform: translateY(1px) scale(0.99);
    box-shadow: 0 2px 8px rgba(0,0,0,0.10);
  }
  .api-key-form-button:focus-visible {
    outline: 2px solid var(--color-border);
    outline-offset: 2px;
  }
  .api-key-form-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    filter: none;
  }
  .api-key-label {
    margin-right: 10px;
    font-weight: bold;
    color: var(--color-text);
  }
  .api-key-id {
    margin-right: 10px;
    font-family: monospace;
    color: var(--color-text);
  }
  .api-key-status {
    margin-right: 10px;
    font-weight: bold;
  }
  .api-key-created {
    color: var(--color-text);
  }
  .api-key-status-active .api-key-status {
    color: var(--color-safe);
  }
  .api-key-status-inactive .api-key-status,
  .api-key-status-expired .api-key-status {
    color: var(--color-danger);
  }
  .api-key-expiration {
    color: var(--color-text);
  }
  .api-key-last-used {
    color: var(--color-text);
  }
  .api-keys-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
    background: var(--color-bg);
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 10px rgba(0,0,0,0.04);
  }
  .api-keys-table th, .api-keys-table td {
    padding: 10px 12px;
    text-align: left;
    border-bottom: 1px solid var(--color-border);
  }
  .api-keys-table th {
    background: var(--color-frame-bg);
    color: var(--color-text);
    font-weight: bold;
  }
  .api-keys-table tr:last-child td {
    border-bottom: none;
  }
  </style> 